import Immutable from 'immutable';

export const createIndex = (entityMap, indexField) => {
  return entityMap
    .groupBy((entity) => entity.get(indexField).toString())
    .map((groupedEntities) => groupedEntities.keySeq());
};

export const createNormalizedStoreUpdater = (reducerKeyPaths = [], source) => {
  return (state) =>
    state.withMutations((map) => {
      reducerKeyPaths.forEach((item) => {
        // if item is an array assume it's a full merge path with entity key as the first element
        const keyPath = item.constructor === Array ? item : [item];
        const entityKey = keyPath[0];
        map.mergeIn(keyPath, Immutable.fromJS(source[entityKey]));
      });
    });
};

export const reindexMapFromIds = (entityIds, entityMap, indexField) => {
  return (
    entityIds &&
    entityIds.reduce((acc, entityId) => {
      const item = entityMap.get(entityId.toString());
      return item ? acc.set(item.get(indexField).toString(), item) : acc;
    }, Immutable.Map())
  );
};
